import { motion } from 'framer-motion'

const PATHS = [
  'M4360 7363 c-275 -18 -519 -83 -765 -203 -422 -205 -742 -522 -949 -941 -81 -164 -151 -370 -136 -400 8 -14 19 -19 38 -17 25 3 30 12 69 128 247 726 856 1230 1613 1336 139 20 460 14 585 -9 290 -55 534 -153 765 -308 364 -245 628 -590 771 -1009 44 -131 46 -135 74 -135 50 0 52 22 13 141 -180 553 -584 1003 -1114 1242 -295 132 -649 197 -964 175z',
  'M580 5654 c261 -65 1678 -417 2719 -675 421 -104 768 -188 772 -187 4 2 -68 208 -160 458 l-167 455 -1690 2 -1689 1 215 -54z',
  'M5300 5688 c-27 -61 -328 -893 -325 -896 2 -2 235 53 517 123 1169 289 2855 708 3018 749 l175 44 -1688 1 -1687 1 -10 -22z',
  'M4081 5053 c39 -104 154 -416 256 -696 114 -308 190 -502 195 -494 4 8 117 313 252 678 134 365 248 672 251 682 7 16 -21 17 -508 17 l-515 0 69 -187z',
  'M2472 5068 c-42 -42 46 -389 162 -633 166 -349 445 -660 778 -867 467 -290 1068 -378 1605 -233 753 202 1328 817 1480 1582 22 109 24 134 14 147 -14 17 -56 22 -65 8 -2 -4 -16 -66 -31 -137 -161 -799 -778 -1406 -1580 -1556 -139 -26 -410 -36 -555 -20 -225 25 -436 85 -639 182 -565 271 -959 779 -1085 1400 -14 67 -31 126 -38 131 -18 11 -32 10 -46 -4z',
]

/**
 * El cóndor de Kuntur (mismo trazo del logo de siempre).
 * `animate` lo hace entrar por piezas: primero las alas, luego el cuerpo y el sol —
 * se usa en el login y al abrir el riel, nunca en bucle.
 */
export default function KunturMark({ width = 64, color = 'currentColor', animate = false }: { width?: number; color?: string; animate?: boolean }) {
  const order = [3, 0, 1, 2, 4] // sol, alas, cuerpo
  return (
    <svg width={width} height={width * 0.543} viewBox="50 150 810 440" fill={color} xmlns="http://www.w3.org/2000/svg" aria-label="Kuntur">
      <g transform="translate(0,909) scale(0.1,-0.1)">
        {PATHS.map((d, i) =>
          animate ? (
            <motion.path
              key={i}
              d={d}
              initial={{ opacity: 0, y: i === 1 || i === 2 ? 0 : 120, scale: 0.96 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              transition={{ delay: 0.12 * order.indexOf(i), duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
              style={{ transformOrigin: '4500px 5600px' }}
            />
          ) : (
            <path key={i} d={d} />
          ),
        )}
      </g>
    </svg>
  )
}
